import React, { useState, useEffect, useCallback } from 'react';
import { FlatList, View } from 'react-native';
import Book from './Book';
import { useGetBookItemLayout, useFlatListPadding } from '../hooks';
import { useIsFocused } from '@react-navigation/native';
import { keyExtractor, getInitialScreenWidth } from '../utils';

const ITEM_X_SPACING = 20;

export default function BooksList({ books, navigation, refreshing=false, useStickyHeader=false, context, contextId, onRefresh, renderListHeader, renderEmpty=() => null, listId='', groupId, groupSlug }) {
    const containerHorSpacing = 15;
    const [width, setWidth] = useState(getInitialScreenWidth(navigation));
    const [pressedBookId, setPressedBookId] = useState(null);
    const {columns, itemWidth} = useGetBookItemLayout(width, containerHorSpacing, ITEM_X_SPACING);
    const isFocused = useIsFocused();
    useEffect(() => {
        if(isFocused && pressedBookId) {
            setPressedBookId(null);
        }
    }, [isFocused])
    const rememberPressedBookId = useCallback((bookId) => setPressedBookId(bookId), []);
    const renderItem = ({ item }) => (
        <Book 
            bookId={item.id}
            title={item.title}
            author={item.author}
            listId={listId}
            groupId={groupId}
            groupSlug={groupSlug}
            width={itemWidth} 
            isFocused={isFocused}
            ownerId={item.ownerId}
            context={context}
            contextId={contextId}
            rememberPressedBookId={rememberPressedBookId}
            pressedBookId={pressedBookId}
            marginHorizontal={ITEM_X_SPACING/2} 
            navigation={navigation} />
    )
    const onLayout = ({ nativeEvent: { layout } }) => {
        if(layout.width && layout.width != width) setWidth(layout.width);
    }
    const { paddingTop, paddingBottom } = useFlatListPadding();
    const ListHeaderComponent = renderListHeader || (() => <View style={{paddingTop}} />);
    return (
        <FlatList 
            contentContainerStyle={{ flexGrow: 1, marginHorizontal: containerHorSpacing, paddingBottom }}
            data={books} 
            key={columns}
            onLayout={onLayout}
            numColumns={columns}
            refreshing={refreshing}
            onRefresh={onRefresh}
            stickyHeaderIndices={useStickyHeader ? [0] : []}
            ListHeaderComponent={ListHeaderComponent}
            ListEmptyComponent={renderEmpty}
            keyExtractor={keyExtractor}
            renderItem={renderItem} />
    )
}